import axios from 'axios';

export const addToCart = async (packageId: number, arrivalDate: string, departureDate: string) => {
  const sessionId = localStorage.getItem('sessionId');
  if (!sessionId) {
    throw new Error('Session ID not found');
  }

  // const payload = {
  //   campSiteId,
  //   arrivalDate,
  //   departureDate,
  //   sessionId
  // };

  
  const payload = {
    packageId,
    arrivalDate,
    departureDate,
    sessionId
  };

  console.log('Payload:', payload);

  try {
    const response = await axios.post<{ data: { data: any } }>(`${process.env.REACT_APP_API_URL}/ShoppingCart/addToCart`, payload);
    return response.data.data;
  } catch (error) {
    console.error('Error adding to cart:', error);
    return null;
  }
};
